import api from "@/services/api";

export const state = {
  users: [],
  user: {},
};

export const mutations = {
  INIT_USERS(state, payload) {
    state.users = payload;
  },
  INIT_USER(state, payload) {
    state.user = payload;
  },
};

export const actions = {
  getUsers({ commit }, payload) {
    return api.getUsers(payload).then((response) => {
        commit("INIT_USERS", response.data.data);
      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getUserById({ commit }, payload) {
    return api.getUserById(payload).then((response) => {
      commit("INIT_USER", response.data.data);
    });
  },
};

export const getters = {
  getUsers: (state) => state.users,
  getUser: (state) => state.user,
};
